<template>
  <div>
    <table-with-search
      :items="schedules"
      :headers="allHeaders"
      :openDialog="openDialog"
      @headersUpdated="updateHeaders"
      @refreshItems="refreshItems"
      :showRefresh="true"
    />
    <v-dialog
      v-model="openForm"
      max-width="580px"
      persistent
      @keydown.esc="cancel"
    >
      <v-card max-width="580px">
        <v-card-title class="d-flex justify-center pb-6">
          {{ mode }}
        </v-card-title>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mx-1"
        >
          {{ alertValidate }}</v-alert
        >
        <v-form
          @submit.prevent="saveForm"
          class="mx-5"
          ref="form"
          v-model="valid"
        >
          <date-with-check :showCheck="true" class="mb-6" />
          <v-select
            required
            :rules="rules"
            label="Horario"
            dense
            outlined
            v-model="data.schedule"
            :items="allSchedules"
            item-value="scheduleId"
            item-text="name"
            @change="changeSchedule(data.schedule)"
            :disabled="type == 'edit'"
          />
          <v-select
            required
            :rules="rules"
            label="Segmento"
            dense
            outlined
            v-model="data.segment"
            :items="segment"
            item-value="segmId"
            item-text="segment"
            @change="changeSegment"
          />
          <v-text-field
            :label="$tc('changeSchedule.sequenceNumber')"
            dense
            outlined
            v-model="data.sequenceNumber"
            disabled
          />

          <v-text-field
            v-model="data.initialDay"
            :label="$tc('changeSchedule.initialDay')"
            outlined
            dense
            type="number"
            :max="initialDay"
            :min="1"
            :rules="rulesDays"
          />

          <div class="d-flex justify-space-between">
            <v-btn class="bt-exit mb-4" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn type="submit" class="bt-acept">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </div>
</template>
<script>
import groups from "../../../store/groups/groups";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import schedules from "../../../store/groups/schedules";
import Snackbar from "../../Complement/Snackbar.vue";
import dateWithCheck from "../../Complement/DateWithCheck.vue";
import date from "../../../store/common/date";
import DeleteDialog from "../../Complement/DeleteDialog.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { TableWithSearch, Snackbar, dateWithCheck, DeleteDialog },
  data() {
    return {
      titleTable: "Grupos_Horarios",
      headers: [
        {
          text: "Horario",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Número de secuencia",
          value: "seqNum",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Segmento desplazamiento",
          value: "segmDespl",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],

      //vease que los headers se definen aca
      openForm: false,
      alert: false,
      textAlert: "No se ha seleccionado un grupo",
      color: null,
      showCard: true,
      color: "",
      titleDelete: "este horario?",
      valid: true,
      typeForm: "",
      itemToDelete: null,
      itemId: null,
      data: {
        schedule: null,
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        fromOld: null,
      },
      error: false,
      type: null,
      alertValidate: "",
      initialDay: null,
      changeSeg: true,
      itemEdit: null,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      rulesDays: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && this.validateDays(v)) ||
          `El número está fuera del rango. El rango válido es de 1 a ${this.initialDay}`,
      ],
    };
  },

  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    title() {
      return groups.state.itemSelected.son;
    },

    mode: {
      get() {
        return schedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    schedules() {
      return schedules.state.schedules;
    },
    allSchedules() {
      return this.$store.state.changeSchedule.schedule;
    },
    segment() {
      return this.$store.state.changeSchedule.segment;
    },
    validInitialDay() {
      return this.initialDay !== null;
    },
    openDelete: {
      get() {
        return schedules.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  methods: {
    async refreshItems() {
      if (groups.state.itemSelected.id) {
        const groupId = groups.state.itemSelected.id;
        await schedules.dispatch("getSchedules", groupId);
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openDialog(type, item) {
      this.type = type;
      switch (type) {
        case "add":
          schedules.commit("setMode", this.$tc("groups.addSchedulTitle"));
          if (this.validGroup()) {
            this.$store.dispatch("changeSchedule/getSchedules").then(() => {
              this.openForm = true;
            });
          }

          break;
        case "edit":
          schedules.commit("setMode", this.$tc("groups.editSchedulTitle"));
          this.$store.dispatch("changeSchedule/getSchedules").then(() => {
            this.openForm = true;
            this.changeSchedule(item.id);

            this.data = {
              schedule: item.id,
              segment: item.segmId,
              initialDay: item.segmDespl,
              sequenceNumber: item.seqNum,
              fromOld: this.formatDate(item.from),
            };
            date.commit("setDateFrom", this.formatDate(item.from));
            date.commit(
              "setDateTo",
              item.to == "" ? null : this.formatDate(item.to)
            );
            date.commit("setCheckTo", item.to == "" ? true : false);
          });

          break;
        case "delete":
          this.openDelete = true;
          schedules.commit("setOpenDelete", true);
          this.itemToDelete = item;
          break;

        default:
          break;
      }
    },

    formatDate(item) {
      const dateToFormat = moment(item, "DD-MM-YYYY");
      let date = dateToFormat.format("YYYY-MM-DD");
      return date;
    },
    validGroup() {
      if (groups.state.itemSelected.son) {
        return true;
      } else {
        this.color = "error";
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 3000);
        return false;
      }
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.resetDate();
      this.openForm = false;
      this.data = {
        schedule: null,
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
      };
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },
    saveForm(value) {
      let payload = {
        ...this.data,
        nameSchedule: this.getName(this.data.schedule).name,
        from: date.state.dateFrom,
        to: date.state.checkTo ? null : date.state.dateTo,
        groupId: groups.state.itemSelected.id,
      };
      if (this.type == "add") {
        this.addSchedule(payload);
      } else {
        this.editSchedule(payload);
      }
    },
    addSchedule(payload) {
      schedules.commit("setNew", payload);
      schedules
        .dispatch("new")
        .then(() => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.addSch")),
            "primary"
          );
        })
        .catch(() => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.errorSch")),
            "error"
          );
        });
      this.cancel();
    },
    editSchedule(payload) {
      schedules.commit("setEdit", payload);
      schedules
        .dispatch("edit")
        .then(() => {
          this.openForm = false;
          this.showAlert(
            (this.textAlert = this.$tc("groups.editSch")),
            "primary"
          );
        })
        .catch((e) => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.errorEditSch")),
            "error"
          );
        });
      this.cancel();
    },
    deleteItem() {
      schedules.commit("setDeleteItem", this.itemToDelete);
      schedules
        .dispatch("delete")
        .then(() => {
          schedules.commit("setOpenDelete", false);
          this.showAlert(
            (this.textAlert = this.$tc("groups.deleteSch")),
            "primary"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("groups.errorDeleteSch"), "error");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDelete", false);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    changeSchedule(item) {
      this.$store.commit("changeSchedule/setScheduleId", item);
      this.$store.dispatch("changeSchedule/getSegment");
    },
    changeSegment() {
      this.changeSeg = false;

      this.$store.commit("changeSchedule/setSegmId", this.data.segment);
      this.$store.dispatch("changeSchedule/getSequence").then(() => {
        this.data.sequenceNumber =
          this.$store.state.changeSchedule.numsequence[0].id;
        this.initialDay = this.initialDays(this.data.segment);
      });
    },
    initialDays(selectedData) {
      let inicialDay = this.$store.state.changeSchedule.segment.filter(
        (option) => {
          return option.segmId == selectedData;
        }
      );
      return inicialDay[0]?.days;
    },
    validateDays(value) {
      if (!this.validInitialDay) {
        return true;
      }
      return value >= 1 && value <= this.initialDay;
    },
    getName(id) {
      const name = this.$store.state.changeSchedule.schedule.find(
        (sch) => sch.scheduleId === id
      );
      return name;
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
